import React from "react";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import { filterBy } from "@progress/kendo-data-query";
import PropTypes from "prop-types";
import { FluentTooltip } from "../../../../../components/FluentUI/Fluent-Tooltip";

export const DropDownCellType = (props) => {
  const [data, setData] = React.useState({
    allData: [],
    filteredData: [],
  });
  const [value, setValue] = React.useState(null);

  React.useEffect(() => {
    const dataForDropdown = props.list.Conditions.map((text, index) => ({
      id: index,
      text,
    }));

    setData({
      allData: dataForDropdown,
      filteredData: dataForDropdown,
    });

    // Set initial value based on dataItem and field, if needed
    const initialValue = dataForDropdown.find(
      (item) => item.text === props.dataItem[props.field]
    );
    setValue(initialValue || null);
  }, [props.conditions, props.dataItem, props.field]);

  const handleChange = (e) => {
    console.log("Change detected -->");
    if (e.target.value !== null) {
      props.onChange({
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.text,
      });
      setValue(e.target.value);
    } else {
      setValue(null);
    }
  };

  const filterChange = (event) => {
    setData((prev) => ({
      ...prev,
      filteredData: filterBy(data.allData, event.filter),
    }));
  };

  return !props.dataItem?.inEdit ? (
    <FluentTooltip
      target={
        <td className="k-table-td">
          {value === null ? "" : value.text.toString()}
        </td>
      }
      text={value === null ? "" : value.text.toString()}
    ></FluentTooltip>
  ) : (
    <td className="k-table-td">
      <ComboBox
        data={data.filteredData}
        textField="text"
        valueField="id"
        onFilterChange={filterChange}
        onChange={handleChange}
        value={value}
        title={value === null ? "" : value?.text?.toString()}
        clearButton={true}
      />
    </td>
  );
};

DropDownCellType.propTypes = {
  dataItem: PropTypes.object,
  field: PropTypes.string,
  conditions: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
};